app.controller('TransferFormController', function ($location, $state, $mdDialog, $stateParams, $q, SessionService) {
        const vm = this;
    vm.closingClinics = SessionService.data.closingClinics;
    vm.transfer = {};
    vm.loading = false;
    vm.transfer.postcodeRadius = "25";
    vm.mobileRegex = SessionService.mobileRegex;
    vm.emailRegex = SessionService.emailRegex;
    vm.alphanumericRegex = SessionService.alphanumericRegex;
    // vm.currentLocation = SessionService.getCurrentPosition().then(location => {
    //     vm.hasLocation = true;
    //     vm.geoLocation = location;
    // }, () => {
    //     vm.hasLocation = false;
    // });
    vm.resetForm = function () {
        vm.transfer = {};
        vm.loading = false;
        vm.verificationError = false;
        vm.moveConsentGiven = false;
        vm.leaveConsentGiven = false;
        vm.findError = false;
        vm.error = null;
    };
    // const testSettings = function () {
    //     SessionService.findClinicsByPostcode({postcode: "wd3 6ar"}).then(clinics => {
    //         vm.transfer.optionSelected = true;
    //         vm.clinicList = clinics;
    //         vm.loading = false;
    //     }, error => {
    //         vm.loading = false;
    //         vm.error = error.msg;
    //     });
    //     vm.transfer.verified = true;
    //     vm.transfer.postcode = "wd3 6ar";
    //     vm.transfer.transferEntry = "1";
    //     vm.transfer.optionSelected = true;
    //     vm.transfer.option = "leave";
    // };
    // testSettings();
        if (SessionService.data.error) {
            vm.loading = false;
            vm.error = {message: SessionService.data.error};
        }
        if ($stateParams.stateError) {
            vm.loading = false;
            vm.error = {message: "Unable to load VetBooker. Please try again later. We apologise for the inconvenience"};
        }
        if ($stateParams.clinicCode) {
            vm.transfer.clinicCode = $stateParams.clinicCode;
        }
        if ($stateParams.registration != null) {
            vm.selection = 'register';
        }
        vm.embedded = $stateParams.embedded;
        vm.visibleBox = "login-box";
        vm.verifyPassword = null;
    vm.resendCode = function () {
        vm.codeLoading = true;
        vm.error = null;
        SessionService.resendCode(vm.transfer.client.transferEntry).then(() => {
            vm.codeLoading = false;
            vm.resendCodeDone = true;
            }, () => {
            vm.resendCodeDone = true;
            vm.codeLoading = false;
                vm.error = "Unable to resend SMS code, please contact the clinic";
            });
        };
        vm.showAgreement = function () {
            $mdDialog.show({
                controller: ClientAgreementDialogController,
                controllerAs: 'dialogCtrl',
                templateUrl: vm.isGroomRoom ? 'main/pets-client-agreement.html' : 'main/client-agreement.html'
            }).then(function () {
            }, function (error) {
            });
        };

        vm.resetError = function () {
            vm.error = {};
        };
    vm.getClientNumber = function () {
            const deferred = $q.defer();
            vm.loading = true;
        vm.findError = false;
        SessionService.getClientNumber(vm.transfer).then(client => {
            vm.loading = false;
            vm.transfer.client = client;
            deferred.resolve();
        }, () => {
            vm.findError = true;
            vm.loading = false;
            deferred.reject();
        });
            return deferred.promise;
        };
    vm.verifyContact = function () {
            const deferred = $q.defer();
            vm.loading = true;
        vm.verificationError = false;
        SessionService.verifyContact(vm.transfer.transferEntry, vm.transfer.verification).then(() => {
                vm.loading = false;
            vm.transfer.verified = true;
                deferred.resolve();
        }, () => {
            vm.verificationError = true;
                vm.loading = false;
                deferred.reject();
            });
            return deferred.promise;
        };
    vm.finishWizard = function () {
        const deferred = $q.defer();
        vm.loading = true;
        vm.error = null;
        const transferPackage = {
            transferId: vm.transfer.transferEntry,
            option: vm.transfer.option,
            newClinicEmail: vm.transfer.newClinicEmail,
            newClientId: vm.transfer.newClientId,
        };
        if (vm.transfer.selectedClinic) {
            transferPackage.newClinicId = vm.transfer.selectedClinic.objectId
        }
        SessionService.finishWizard(transferPackage).then(() => {
            vm.loading = false;
            vm.wizardFinished = true;
            deferred.resolve("Done");
        }, error => {
            vm.error = error.msg;
            vm.loading = false;
            deferred.reject(error);
        });
        return deferred.promise;
    };

    vm.selectOption = function () {
        const deferred = $q.defer();
        vm.loading = true;
        vm.error = null;
        if (vm.transfer.option === 'move') {
            vm.clinicsLoading = true;
            SessionService.findClinicsByPostcode({
                postcode: vm.transfer.postcode,
                radius: vm.transfer.postcodeRadius
            }).then(clinics => {
                vm.transfer.optionSelected = true;
                vm.clinicList = clinics;
                vm.clinicsLoading = false;
                vm.loading = false;
            }, error => {
                vm.loading = false;
                vm.clinicsLoading = false;
                vm.error = error.msg;
            });
        } else if (vm.transfer.option === 'leave') {
            vm.transfer.optionSelected = true;
            vm.loading = false;
        }
        return deferred.promise;
    };
    vm.findByPostcode = function () {
        const deferred = $q.defer();
        vm.clinicsLoading = true;
        vm.error = null;
        SessionService.findClinicsByPostcode({
            postcode: vm.transfer.postcode,
            radius: vm.transfer.postcodeRadius
        }).then(clinics => {
            vm.clinicList = clinics;
            vm.clinicsLoading = false;
        }, error => {
            vm.clinicsLoading = false;
            vm.error = error.msg;
        });
        return deferred.promise;
    };
    vm.selectClinic = function (clinic) {
        vm.transfer.selectedClinic = clinic;
    };

    function ClientAgreementDialogController($mdDialog) {
            const vm = this;
            vm.hide = function () {
                $mdDialog.hide();
            };
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }

    }
);